var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckboxOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 14,
    height: 14,
    rx: 2,
    fill: "var(--theme500, #e6007a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1714 5.14367C12.4372 5.40946 12.4372 5.84038 12.1714 6.10616L6.97513 11.3024C6.8475 11.4301 6.67439 11.5018 6.49389 11.5018C6.31339 11.5018 6.14028 11.4301 6.01264 11.3024L3.78567 9.07546C3.51989 8.80967 3.51989 8.37875 3.78567 8.11297C4.05146 7.84719 4.48238 7.84719 4.74816 8.11297L6.49389 9.8587L11.2089 5.14367C11.4747 4.87789 11.9056 4.87789 12.1714 5.14367Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxOn);
export default __webpack_public_path__ + "static/media/checkbox-on.301091cd749bfcde2b149b4bbcf2df6f.svg";
export { ForwardRef as ReactComponent };